<template>
  <div
    class="product-detail-redesign-skeleton"
    aria-busy="true"
    aria-live="polite"
    aria-label="Cargando detalle de producto"
  >
    <div class="product-detail-redesign-skeleton__panel rounded-shadow">
      <div class="row">
        <div class="col-lg-4 col-sm-12">
          <div class="product-detail-redesign-skeleton__image" />
          <div class="product-detail-redesign-skeleton__price-box">
            <div class="product-detail-redesign-skeleton__line" />
            <div class="product-detail-redesign-skeleton__line" />
            <div class="product-detail-redesign-skeleton__line product-detail-redesign-skeleton__line--short" />
          </div>
          <div class="product-detail-redesign-skeleton__button" />
        </div>
        <div class="col-lg-8 col-sm-12">
          <div class="product-detail-redesign-skeleton__line product-detail-redesign-skeleton__line--heading" />
          <div
            class="product-detail-redesign-skeleton__line"
            v-for="n in 6"
            :key="'row-' + n"
          />
          <div class="product-detail-redesign-skeleton__tabs">
            <span
              v-for="n in 3"
              :key="'tab-' + n"
              class="product-detail-redesign-skeleton__tab"
            />
          </div>
          <div class="product-detail-redesign-skeleton__block" />
          <div class="product-detail-redesign-skeleton__line" />
          <div class="product-detail-redesign-skeleton__line product-detail-redesign-skeleton__line--medium" />
        </div>
      </div>
    </div>
    <div class="product-detail-redesign-skeleton__similar">
      <div class="product-detail-redesign-skeleton__line product-detail-redesign-skeleton__line--section" />
      <div class="row">
        <div class="col-md-3" v-for="n in 4" :key="'sim-' + n">
          <div class="product-detail-redesign-skeleton__similar-card">
            <div class="product-detail-redesign-skeleton__similar-image" />
            <div class="product-detail-redesign-skeleton__line product-detail-redesign-skeleton__line--card" />
            <div class="product-detail-redesign-skeleton__line product-detail-redesign-skeleton__line--card-short" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ProductDetailRedesignSkeleton',
};
</script>

<style lang="scss" src="./ProductDetailRedesignSkeleton.scss"></style>
